// extracted by mini-css-extract-plugin
export var wrap = "Terms-module--wrap--2m-KZ";
export var top = "Terms-module--top--3Z5-2";
export var content = "Terms-module--content--3iakm";